export default "__VITE_ASSET__76cMMdPA__"